/**
 * 查询全部下属（含离职）：POST queryAllSubordinates
 */

/** 规范化下属字段 */
export function normalizeSubordinate(item = {}) {
  return {
    jobNumber: item.jobNumber || '',
    qwUserId: item.qwUserId || item.businessWxId || item.userId || '',
    dingUserId: item.dingUserId || '',
    sysUserId: item.sysUserId != null && item.sysUserId !== '' ? item.sysUserId : (item.businessUserId != null && item.businessUserId !== '' ? item.businessUserId : ''),
    userName: item.userName || item.businessName || '',
  }
}

/**
 * @param {object} params
 * @param {string} [params.jobNumber]
 * @param {string} [params.qwUserId] 企微 userId（通常传当前登录人，查其下属）
 * @param {number} [params.sysUserId]
 * @param {0|1} [params.isDel] 不传=全部（含离职）；0=在职；1=已离职
 */
export async function fetchAllSubordinates(params = {}) {
  const body = {}
  if (params.jobNumber != null && params.jobNumber !== '') {
    body.jobNumber = params.jobNumber
  }
  if (params.qwUserId != null && params.qwUserId !== '') {
    body.qwUserId = params.qwUserId
  }
  if (params.sysUserId != null && params.sysUserId !== '') {
    body.sysUserId = params.sysUserId
  }
  if (params.isDel === 0 || params.isDel === 1) {
    body.isDel = params.isDel
  }

  const res = await $http.post('queryAllSubordinates', body)
  const { code, data } = res || {}
  const list = Array.isArray(data) ? data.map(normalizeSubordinate) : []
  return { ...(res || {}), code, data: list }
}
